<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">SYSTEM FEED</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="feeds">
      <transition-group name="list" tag="p">
        <div v-for="f in feeds.slice(-100).reverse()" v-bind:key="f">
          <p v-bind:class="f.color">
            <span>{{ f.message }}</span>
          </p>
        </div>
      </transition-group>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      feeds: JSON.parse(localStorage.getItem("System_Feed")) || [],
      expanded: null
    };
  },
  created() {
    this.$socket.off("system_feed");
    this.$socket.on(
      "system_feed",
      function(data) {
        this.feeds = this.feeds.slice(-100);
        this.feeds.push(data);
        localStorage.setItem("System_Feed", JSON.stringify(this.feeds));
      }.bind(this)
    );
  }
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
  animation-name: example;
  animation-duration: 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@keyframes example {
  from {
    background-color: #f6a821;
  }
  to {
    background-color: none;
  }
}
</style>
